import moment from 'moment';

export default date => moment(date).format('DD/MM/YYYY');
